unit View.Boletos.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils;

type
  TFViewBoletosList = class(TForm)
    btNew: TButton;
    BoletosDataset: TXDataWebDataSet;
    BoletosDatasetid: TIntegerField;
    BoletosDatasetaliado_id: TIntegerField;
    BoletosDatasetdata_base_id: TIntegerField;
    BoletosDatasetcliente_id: TIntegerField;
    BoletosDatasetconta_id: TIntegerField;
    BoletosDatasetfuncionario_id: TIntegerField;
    BoletosDatasetstatus_titulo_id: TIntegerField;
    BoletosDatasetvalor: TFloatField;
    BoletosDatasetdata_vencimento: TDateTimeField;
    BoletosDatasetdata_processamento: TDateTimeField;
    BoletosDatasetnosso_numero: TStringField;
    BoletosDatasetnosso_numero_dv: TStringField;
    BoletosDatasetlinha_digitavel: TStringField;
    BoletosDatasetcodigo_barras: TStringField;
    BoletosDatasetbanco_carteira_id: TIntegerField;
    BoletosDatasetdocumento: TStringField;
    BoletosDatasetmensagem1: TStringField;
    BoletosDatasetmensagem2: TStringField;
    BoletosDatasetmensagem3: TStringField;
    BoletosDatasettaxa_juros: TFloatField;
    BoletosDatasettaxa_multa: TFloatField;
    BoletosDatasetarquivo_retorno: TStringField;
    BoletosDatasetdata_retorno: TDateTimeField;
    BoletosDatasetdata_emissao: TDateTimeField;
    BoletosDatasetcodigo_carteira: TIntegerField;
    BoletosDatasetparcela: TStringField;
    BoletosDatasetdata_pagamento: TDateTimeField;
    BoletosDatasetvalor_pago: TFloatField;
    BoletosDatasetvalor_novo: TFloatField;
    BoletosDatasetdata_vencimento_nova: TDateTimeField;
    BoletosDatasettipo_liquidacao_antecipada: TIntegerField;
    BoletosDatasetid_boleto_digital: TStringField;
    BoletosDatasetboleto_digital: TBooleanField;
    BoletosDatasetid_externo: TStringField;
    BoletosDatasetnumero_titulo_cliente: TStringField;
    BoletosDataseturl_boleto: TStringField;
    BoletosDatasetcodigo_interno: TIntegerField;
    BoletosDatasetexcluido: TBooleanField;
    BoletosDatasetinclusao: TDateTimeField;
    BoletosDatasetalteracao: TDateTimeField;
    BoletosDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewBoletosList: TFViewBoletosList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewBoletosList }

procedure TFViewBoletosList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewBoletosList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewBoletosList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewBoletosList, AElementID, Result, @AfterCreate);
end;

procedure TFViewBoletosList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewBoletosList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewBoletosList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewBoletosList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewBoletosList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      BoletosDataset.Connection.Model.DefaultSchema.FindEntityType(BoletosDataset.EntitySetName),
      BoletosDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewBoletosList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('boletos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    BoletosDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewBoletosList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.boletos.list.pagination.info');
  btNew := TButton.Create('view.boletos.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.boletos.list.table');
  cbPageSize := TComboBox.Create('view.boletos.list.cbPageSize');
  edSearch := TEdit.Create('view.boletos.list.search');
  lcPaginator := TListControl.Create('view.boletos.list.pagination');
  BoletosDataset := TXDataWebDataSet.Create(Self);
  BoletosDatasetid := TIntegerField.Create(Self);
  BoletosDatasetaliado_id := TIntegerField.Create(Self);
  BoletosDatasetdata_base_id := TIntegerField.Create(Self);
  BoletosDatasetcliente_id := TIntegerField.Create(Self);
  BoletosDatasetconta_id := TIntegerField.Create(Self);
  BoletosDatasetfuncionario_id := TIntegerField.Create(Self);
  BoletosDatasetstatus_titulo_id := TIntegerField.Create(Self);
  BoletosDatasetvalor := TFloatField.Create(Self);
  BoletosDatasetdata_vencimento := TDateTimeField.Create(Self);
  BoletosDatasetdata_processamento := TDateTimeField.Create(Self);
  BoletosDatasetnosso_numero := TStringField.Create(Self);
  BoletosDatasetnosso_numero_dv := TStringField.Create(Self);
  BoletosDatasetlinha_digitavel := TStringField.Create(Self);
  BoletosDatasetcodigo_barras := TStringField.Create(Self);
  BoletosDatasetbanco_carteira_id := TIntegerField.Create(Self);
  BoletosDatasetdocumento := TStringField.Create(Self);
  BoletosDatasetmensagem1 := TStringField.Create(Self);
  BoletosDatasetmensagem2 := TStringField.Create(Self);
  BoletosDatasetmensagem3 := TStringField.Create(Self);
  BoletosDatasettaxa_juros := TFloatField.Create(Self);
  BoletosDatasettaxa_multa := TFloatField.Create(Self);
  BoletosDatasetarquivo_retorno := TStringField.Create(Self);
  BoletosDatasetdata_retorno := TDateTimeField.Create(Self);
  BoletosDatasetdata_emissao := TDateTimeField.Create(Self);
  BoletosDatasetcodigo_carteira := TIntegerField.Create(Self);
  BoletosDatasetparcela := TStringField.Create(Self);
  BoletosDatasetdata_pagamento := TDateTimeField.Create(Self);
  BoletosDatasetvalor_pago := TFloatField.Create(Self);
  BoletosDatasetvalor_novo := TFloatField.Create(Self);
  BoletosDatasetdata_vencimento_nova := TDateTimeField.Create(Self);
  BoletosDatasettipo_liquidacao_antecipada := TIntegerField.Create(Self);
  BoletosDatasetid_boleto_digital := TStringField.Create(Self);
  BoletosDatasetboleto_digital := TBooleanField.Create(Self);
  BoletosDatasetid_externo := TStringField.Create(Self);
  BoletosDatasetnumero_titulo_cliente := TStringField.Create(Self);
  BoletosDataseturl_boleto := TStringField.Create(Self);
  BoletosDatasetcodigo_interno := TIntegerField.Create(Self);
  BoletosDatasetexcluido := TBooleanField.Create(Self);
  BoletosDatasetinclusao := TDateTimeField.Create(Self);
  BoletosDatasetalteracao := TDateTimeField.Create(Self);
  BoletosDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  BoletosDataset.BeforeLoadDFMValues;
  BoletosDatasetid.BeforeLoadDFMValues;
  BoletosDatasetaliado_id.BeforeLoadDFMValues;
  BoletosDatasetdata_base_id.BeforeLoadDFMValues;
  BoletosDatasetcliente_id.BeforeLoadDFMValues;
  BoletosDatasetconta_id.BeforeLoadDFMValues;
  BoletosDatasetfuncionario_id.BeforeLoadDFMValues;
  BoletosDatasetstatus_titulo_id.BeforeLoadDFMValues;
  BoletosDatasetvalor.BeforeLoadDFMValues;
  BoletosDatasetdata_vencimento.BeforeLoadDFMValues;
  BoletosDatasetdata_processamento.BeforeLoadDFMValues;
  BoletosDatasetnosso_numero.BeforeLoadDFMValues;
  BoletosDatasetnosso_numero_dv.BeforeLoadDFMValues;
  BoletosDatasetlinha_digitavel.BeforeLoadDFMValues;
  BoletosDatasetcodigo_barras.BeforeLoadDFMValues;
  BoletosDatasetbanco_carteira_id.BeforeLoadDFMValues;
  BoletosDatasetdocumento.BeforeLoadDFMValues;
  BoletosDatasetmensagem1.BeforeLoadDFMValues;
  BoletosDatasetmensagem2.BeforeLoadDFMValues;
  BoletosDatasetmensagem3.BeforeLoadDFMValues;
  BoletosDatasettaxa_juros.BeforeLoadDFMValues;
  BoletosDatasettaxa_multa.BeforeLoadDFMValues;
  BoletosDatasetarquivo_retorno.BeforeLoadDFMValues;
  BoletosDatasetdata_retorno.BeforeLoadDFMValues;
  BoletosDatasetdata_emissao.BeforeLoadDFMValues;
  BoletosDatasetcodigo_carteira.BeforeLoadDFMValues;
  BoletosDatasetparcela.BeforeLoadDFMValues;
  BoletosDatasetdata_pagamento.BeforeLoadDFMValues;
  BoletosDatasetvalor_pago.BeforeLoadDFMValues;
  BoletosDatasetvalor_novo.BeforeLoadDFMValues;
  BoletosDatasetdata_vencimento_nova.BeforeLoadDFMValues;
  BoletosDatasettipo_liquidacao_antecipada.BeforeLoadDFMValues;
  BoletosDatasetid_boleto_digital.BeforeLoadDFMValues;
  BoletosDatasetboleto_digital.BeforeLoadDFMValues;
  BoletosDatasetid_externo.BeforeLoadDFMValues;
  BoletosDatasetnumero_titulo_cliente.BeforeLoadDFMValues;
  BoletosDataseturl_boleto.BeforeLoadDFMValues;
  BoletosDatasetcodigo_interno.BeforeLoadDFMValues;
  BoletosDatasetexcluido.BeforeLoadDFMValues;
  BoletosDatasetinclusao.BeforeLoadDFMValues;
  BoletosDatasetalteracao.BeforeLoadDFMValues;
  BoletosDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewBoletosList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente_id';
      Title := 'cliente_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_id';
      Title := 'conta_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status_titulo_id';
      Title := 'status_titulo_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor';
      Title := 'valor';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_vencimento';
      Title := 'data_vencimento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_processamento';
      Title := 'data_processamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nosso_numero';
      Title := 'nosso_numero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nosso_numero_dv';
      Title := 'nosso_numero_dv';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'linha_digitavel';
      Title := 'linha_digitavel';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_barras';
      Title := 'codigo_barras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'banco_carteira_id';
      Title := 'banco_carteira_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem1';
      Title := 'mensagem1';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem2';
      Title := 'mensagem2';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensagem3';
      Title := 'mensagem3';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_juros';
      Title := 'taxa_juros';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_multa';
      Title := 'taxa_multa';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'arquivo_retorno';
      Title := 'arquivo_retorno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_retorno';
      Title := 'data_retorno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_emissao';
      Title := 'data_emissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_carteira';
      Title := 'codigo_carteira';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'parcela';
      Title := 'parcela';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_pagamento';
      Title := 'data_pagamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pago';
      Title := 'valor_pago';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_novo';
      Title := 'valor_novo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_vencimento_nova';
      Title := 'data_vencimento_nova';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo_liquidacao_antecipada';
      Title := 'tipo_liquidacao_antecipada';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id_boleto_digital';
      Title := 'id_boleto_digital';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'boleto_digital';
      Title := 'boleto_digital';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id_externo';
      Title := 'id_externo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero_titulo_cliente';
      Title := 'numero_titulo_cliente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'url_boleto';
      Title := 'url_boleto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    BoletosDataset.SetParentComponent(Self);
    BoletosDataset.Name := 'BoletosDataset';
    BoletosDataset.EntitySetName := 'Boletos';
    BoletosDataset.Connection := DMConnection.ApiConnection;
    BoletosDataset.Left := 72;
    BoletosDataset.Top := 144;
    BoletosDatasetid.SetParentComponent(BoletosDataset);
    BoletosDatasetid.Name := 'BoletosDatasetid';
    BoletosDatasetid.FieldName := 'id';
    BoletosDatasetid.Required := True;
    BoletosDatasetaliado_id.SetParentComponent(BoletosDataset);
    BoletosDatasetaliado_id.Name := 'BoletosDatasetaliado_id';
    BoletosDatasetaliado_id.FieldName := 'aliado_id';
    BoletosDatasetaliado_id.Required := True;
    BoletosDatasetdata_base_id.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_base_id.Name := 'BoletosDatasetdata_base_id';
    BoletosDatasetdata_base_id.FieldName := 'data_base_id';
    BoletosDatasetdata_base_id.Required := True;
    BoletosDatasetcliente_id.SetParentComponent(BoletosDataset);
    BoletosDatasetcliente_id.Name := 'BoletosDatasetcliente_id';
    BoletosDatasetcliente_id.FieldName := 'cliente_id';
    BoletosDatasetconta_id.SetParentComponent(BoletosDataset);
    BoletosDatasetconta_id.Name := 'BoletosDatasetconta_id';
    BoletosDatasetconta_id.FieldName := 'conta_id';
    BoletosDatasetfuncionario_id.SetParentComponent(BoletosDataset);
    BoletosDatasetfuncionario_id.Name := 'BoletosDatasetfuncionario_id';
    BoletosDatasetfuncionario_id.FieldName := 'funcionario_id';
    BoletosDatasetstatus_titulo_id.SetParentComponent(BoletosDataset);
    BoletosDatasetstatus_titulo_id.Name := 'BoletosDatasetstatus_titulo_id';
    BoletosDatasetstatus_titulo_id.FieldName := 'status_titulo_id';
    BoletosDatasetvalor.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor.Name := 'BoletosDatasetvalor';
    BoletosDatasetvalor.FieldName := 'valor';
    BoletosDatasetdata_vencimento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_vencimento.Name := 'BoletosDatasetdata_vencimento';
    BoletosDatasetdata_vencimento.FieldName := 'data_vencimento';
    BoletosDatasetdata_processamento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_processamento.Name := 'BoletosDatasetdata_processamento';
    BoletosDatasetdata_processamento.FieldName := 'data_processamento';
    BoletosDatasetnosso_numero.SetParentComponent(BoletosDataset);
    BoletosDatasetnosso_numero.Name := 'BoletosDatasetnosso_numero';
    BoletosDatasetnosso_numero.FieldName := 'nosso_numero';
    BoletosDatasetnosso_numero.Size := 255;
    BoletosDatasetnosso_numero_dv.SetParentComponent(BoletosDataset);
    BoletosDatasetnosso_numero_dv.Name := 'BoletosDatasetnosso_numero_dv';
    BoletosDatasetnosso_numero_dv.FieldName := 'nosso_numero_dv';
    BoletosDatasetnosso_numero_dv.Size := 255;
    BoletosDatasetlinha_digitavel.SetParentComponent(BoletosDataset);
    BoletosDatasetlinha_digitavel.Name := 'BoletosDatasetlinha_digitavel';
    BoletosDatasetlinha_digitavel.FieldName := 'linha_digitavel';
    BoletosDatasetlinha_digitavel.Size := 255;
    BoletosDatasetcodigo_barras.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_barras.Name := 'BoletosDatasetcodigo_barras';
    BoletosDatasetcodigo_barras.FieldName := 'codigo_barras';
    BoletosDatasetcodigo_barras.Size := 255;
    BoletosDatasetbanco_carteira_id.SetParentComponent(BoletosDataset);
    BoletosDatasetbanco_carteira_id.Name := 'BoletosDatasetbanco_carteira_id';
    BoletosDatasetbanco_carteira_id.FieldName := 'banco_carteira_id';
    BoletosDatasetdocumento.SetParentComponent(BoletosDataset);
    BoletosDatasetdocumento.Name := 'BoletosDatasetdocumento';
    BoletosDatasetdocumento.FieldName := 'documento';
    BoletosDatasetdocumento.Size := 255;
    BoletosDatasetmensagem1.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem1.Name := 'BoletosDatasetmensagem1';
    BoletosDatasetmensagem1.FieldName := 'mensagem1';
    BoletosDatasetmensagem1.Size := 255;
    BoletosDatasetmensagem2.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem2.Name := 'BoletosDatasetmensagem2';
    BoletosDatasetmensagem2.FieldName := 'mensagem2';
    BoletosDatasetmensagem2.Size := 255;
    BoletosDatasetmensagem3.SetParentComponent(BoletosDataset);
    BoletosDatasetmensagem3.Name := 'BoletosDatasetmensagem3';
    BoletosDatasetmensagem3.FieldName := 'mensagem3';
    BoletosDatasetmensagem3.Size := 255;
    BoletosDatasettaxa_juros.SetParentComponent(BoletosDataset);
    BoletosDatasettaxa_juros.Name := 'BoletosDatasettaxa_juros';
    BoletosDatasettaxa_juros.FieldName := 'taxa_juros';
    BoletosDatasettaxa_multa.SetParentComponent(BoletosDataset);
    BoletosDatasettaxa_multa.Name := 'BoletosDatasettaxa_multa';
    BoletosDatasettaxa_multa.FieldName := 'taxa_multa';
    BoletosDatasetarquivo_retorno.SetParentComponent(BoletosDataset);
    BoletosDatasetarquivo_retorno.Name := 'BoletosDatasetarquivo_retorno';
    BoletosDatasetarquivo_retorno.FieldName := 'arquivo_retorno';
    BoletosDatasetarquivo_retorno.Size := 255;
    BoletosDatasetdata_retorno.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_retorno.Name := 'BoletosDatasetdata_retorno';
    BoletosDatasetdata_retorno.FieldName := 'data_retorno';
    BoletosDatasetdata_emissao.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_emissao.Name := 'BoletosDatasetdata_emissao';
    BoletosDatasetdata_emissao.FieldName := 'data_emissao';
    BoletosDatasetcodigo_carteira.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_carteira.Name := 'BoletosDatasetcodigo_carteira';
    BoletosDatasetcodigo_carteira.FieldName := 'codigo_carteira';
    BoletosDatasetparcela.SetParentComponent(BoletosDataset);
    BoletosDatasetparcela.Name := 'BoletosDatasetparcela';
    BoletosDatasetparcela.FieldName := 'parcela';
    BoletosDatasetparcela.Size := 255;
    BoletosDatasetdata_pagamento.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_pagamento.Name := 'BoletosDatasetdata_pagamento';
    BoletosDatasetdata_pagamento.FieldName := 'data_pagamento';
    BoletosDatasetvalor_pago.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor_pago.Name := 'BoletosDatasetvalor_pago';
    BoletosDatasetvalor_pago.FieldName := 'valor_pago';
    BoletosDatasetvalor_novo.SetParentComponent(BoletosDataset);
    BoletosDatasetvalor_novo.Name := 'BoletosDatasetvalor_novo';
    BoletosDatasetvalor_novo.FieldName := 'valor_novo';
    BoletosDatasetdata_vencimento_nova.SetParentComponent(BoletosDataset);
    BoletosDatasetdata_vencimento_nova.Name := 'BoletosDatasetdata_vencimento_nova';
    BoletosDatasetdata_vencimento_nova.FieldName := 'data_vencimento_nova';
    BoletosDatasettipo_liquidacao_antecipada.SetParentComponent(BoletosDataset);
    BoletosDatasettipo_liquidacao_antecipada.Name := 'BoletosDatasettipo_liquidacao_antecipada';
    BoletosDatasettipo_liquidacao_antecipada.FieldName := 'tipo_liquidacao_antecipada';
    BoletosDatasetid_boleto_digital.SetParentComponent(BoletosDataset);
    BoletosDatasetid_boleto_digital.Name := 'BoletosDatasetid_boleto_digital';
    BoletosDatasetid_boleto_digital.FieldName := 'id_boleto_digital';
    BoletosDatasetid_boleto_digital.Size := 255;
    BoletosDatasetboleto_digital.SetParentComponent(BoletosDataset);
    BoletosDatasetboleto_digital.Name := 'BoletosDatasetboleto_digital';
    BoletosDatasetboleto_digital.FieldName := 'boleto_digital';
    BoletosDatasetboleto_digital.Required := True;
    BoletosDatasetid_externo.SetParentComponent(BoletosDataset);
    BoletosDatasetid_externo.Name := 'BoletosDatasetid_externo';
    BoletosDatasetid_externo.FieldName := 'id_externo';
    BoletosDatasetid_externo.Size := 255;
    BoletosDatasetnumero_titulo_cliente.SetParentComponent(BoletosDataset);
    BoletosDatasetnumero_titulo_cliente.Name := 'BoletosDatasetnumero_titulo_cliente';
    BoletosDatasetnumero_titulo_cliente.FieldName := 'numero_titulo_cliente';
    BoletosDatasetnumero_titulo_cliente.Size := 255;
    BoletosDataseturl_boleto.SetParentComponent(BoletosDataset);
    BoletosDataseturl_boleto.Name := 'BoletosDataseturl_boleto';
    BoletosDataseturl_boleto.FieldName := 'url_boleto';
    BoletosDataseturl_boleto.Size := 255;
    BoletosDatasetcodigo_interno.SetParentComponent(BoletosDataset);
    BoletosDatasetcodigo_interno.Name := 'BoletosDatasetcodigo_interno';
    BoletosDatasetcodigo_interno.FieldName := 'codigo_interno';
    BoletosDatasetcodigo_interno.Required := True;
    BoletosDatasetexcluido.SetParentComponent(BoletosDataset);
    BoletosDatasetexcluido.Name := 'BoletosDatasetexcluido';
    BoletosDatasetexcluido.FieldName := 'excluido';
    BoletosDatasetinclusao.SetParentComponent(BoletosDataset);
    BoletosDatasetinclusao.Name := 'BoletosDatasetinclusao';
    BoletosDatasetinclusao.FieldName := 'inclusao';
    BoletosDatasetalteracao.SetParentComponent(BoletosDataset);
    BoletosDatasetalteracao.Name := 'BoletosDatasetalteracao';
    BoletosDatasetalteracao.FieldName := 'alteracao';
    BoletosDatasetexclusao.SetParentComponent(BoletosDataset);
    BoletosDatasetexclusao.Name := 'BoletosDatasetexclusao';
    BoletosDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := BoletosDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    BoletosDataset.AfterLoadDFMValues;
    BoletosDatasetid.AfterLoadDFMValues;
    BoletosDatasetaliado_id.AfterLoadDFMValues;
    BoletosDatasetdata_base_id.AfterLoadDFMValues;
    BoletosDatasetcliente_id.AfterLoadDFMValues;
    BoletosDatasetconta_id.AfterLoadDFMValues;
    BoletosDatasetfuncionario_id.AfterLoadDFMValues;
    BoletosDatasetstatus_titulo_id.AfterLoadDFMValues;
    BoletosDatasetvalor.AfterLoadDFMValues;
    BoletosDatasetdata_vencimento.AfterLoadDFMValues;
    BoletosDatasetdata_processamento.AfterLoadDFMValues;
    BoletosDatasetnosso_numero.AfterLoadDFMValues;
    BoletosDatasetnosso_numero_dv.AfterLoadDFMValues;
    BoletosDatasetlinha_digitavel.AfterLoadDFMValues;
    BoletosDatasetcodigo_barras.AfterLoadDFMValues;
    BoletosDatasetbanco_carteira_id.AfterLoadDFMValues;
    BoletosDatasetdocumento.AfterLoadDFMValues;
    BoletosDatasetmensagem1.AfterLoadDFMValues;
    BoletosDatasetmensagem2.AfterLoadDFMValues;
    BoletosDatasetmensagem3.AfterLoadDFMValues;
    BoletosDatasettaxa_juros.AfterLoadDFMValues;
    BoletosDatasettaxa_multa.AfterLoadDFMValues;
    BoletosDatasetarquivo_retorno.AfterLoadDFMValues;
    BoletosDatasetdata_retorno.AfterLoadDFMValues;
    BoletosDatasetdata_emissao.AfterLoadDFMValues;
    BoletosDatasetcodigo_carteira.AfterLoadDFMValues;
    BoletosDatasetparcela.AfterLoadDFMValues;
    BoletosDatasetdata_pagamento.AfterLoadDFMValues;
    BoletosDatasetvalor_pago.AfterLoadDFMValues;
    BoletosDatasetvalor_novo.AfterLoadDFMValues;
    BoletosDatasetdata_vencimento_nova.AfterLoadDFMValues;
    BoletosDatasettipo_liquidacao_antecipada.AfterLoadDFMValues;
    BoletosDatasetid_boleto_digital.AfterLoadDFMValues;
    BoletosDatasetboleto_digital.AfterLoadDFMValues;
    BoletosDatasetid_externo.AfterLoadDFMValues;
    BoletosDatasetnumero_titulo_cliente.AfterLoadDFMValues;
    BoletosDataseturl_boleto.AfterLoadDFMValues;
    BoletosDatasetcodigo_interno.AfterLoadDFMValues;
    BoletosDatasetexcluido.AfterLoadDFMValues;
    BoletosDatasetinclusao.AfterLoadDFMValues;
    BoletosDatasetalteracao.AfterLoadDFMValues;
    BoletosDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
